module.exports = __webpack_public_path__ + "media/images/twitter-d39e13d4fc6d61cc41061f062074210d.svg";